module.exports = __webpack_public_path__ + "static/media/masaje.9e8fd2a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/masaje.jpg
// module id = 85
// module chunks = 0